import React from 'react';
import Hero from './Hero';
// import Awards from './Awards';
import OpenAccount from '../OpenAccount';
import Stats from './Stats';
import Pricing from './Pricing';
import Education from './Education';
// import Navbar from '../Navbar';
import Footer from '../Footer';
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useCookies } from "react-cookie";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";


function HomePage() {
   return(
    <>
            <Hero/>
            <Stats/>
            <Pricing/>
            <Education/>
            <OpenAccount/>    
            <Footer/>   
            
        </>
    );
        
};

export default HomePage;